// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3bPD2","productName":"Table_productName__1lAlj"};